export default "__VITE_ASSET__DWA$ltx9__"